import React from 'react';
import { DangerousHTML } from './DangerousHTML';

interface ParagraphProps {
  title?: string | null | undefined,
  text: string, // From markdown
}

export const Paragraph: React.FC<ParagraphProps> = ({ title, text }: ParagraphProps) => (
  <div className="paragraph">
    {title && <h3 className="paragraph__title">{title}</h3>}
    <div className="paragraph__text">
      <DangerousHTML
        element="div"
        html={text}
      />
    </div>
  </div>
);
